import $ from 'jquery';
import { jsPDF } from "jspdf";
import { useEffect, useState, useRef } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { LedgerServices } from '../../services/LedgerServices';
import * as BullCache from "../../util/BullCache";
import '../custom.css';
import NumberFormatter from "../components/NumberFormatter";
import html2canvas from "html2canvas";

function TrialBalance() {

  const pdfRef = useRef();
  const [loading, setLoading] = useState(false);
  const [ledger, setLedger] = useState([]);
  const [creditTotalBalance, setCreditTotalBalance] = useState(0);
  const [debitTotalBalance, setDebitTotalBalance] = useState(0);
  const [differenceBalance, setDifferenceBalance] = useState(0);

  var user = BullCache.getFromCache("user");
  const getCurrentDate = () => {
    const date = new Date();

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

useEffect(() => {
  LedgerServices.getTrialBalance({adminId: user.adminId}).then(res => {
    setLoading(false);
    setLedger([]);
    if (res.code === 1 && res.data.accountList.length > 0) {
      setLedger(res.data.accountList);
      setCreditTotalBalance(res.data.creditTotalBalance);
      setDebitTotalBalance(0-res.data.debitTotalBalance);
      setDifferenceBalance(res.data.differenceBalance);
    }
  });
}, []);

  const exportToPDF = () => {
    const input = pdfRef.current;
        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 210; // A4 width in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
            const paddingTop = 20; // Space after the title
            pdf.setFontSize(12); // Set title font size
            pdf.text(process.env.REACT_APP_NAME, 105, 15, { align: "center" }); // Centered title
    
            pdf.addImage(imgData, "PNG", 0, paddingTop, imgWidth, imgHeight);
            pdf.save(`trialbalance_${getCurrentDate()}.pdf`);
        });
  };

  
  const handlePrint = () => {
    const printContent = document.getElementById("printArea");
    const originalTitle = document.title;
    document.title = `trialbalance_${getCurrentDate()}.pdf`; // Set the desired filenam
    const originalContent = document.body.innerHTML;
    
    document.body.innerHTML = printContent.innerHTML;;
    window.print();
    document.title = originalTitle;
    document.body.innerHTML = originalContent;
    window.location.reload(); // Reload the page to restore UI
  };

  return (
    <Card className='white-back mb-4'>
      <Card.Body className='mb-4 ps-1 pe-1'>
      <Row>
          <Col className="text-end pe-3">
              <Button variant="success" onClick={handlePrint} style={{ width: 80 }}>SAVE</Button>
          </Col>
      </Row>

        <div className="table-responsive">
          {loading ? (
            <div className="container vh-100">
              <div className="d-flex align-items-center justify-content-center h-90">
                <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            <div ref={pdfRef} id="printArea"  style={{ marginTop: "10px"}}>
    <Table hover className="mt-1 mb-0" responsive >
      <thead>
        <tr className="bg-thead" >
          <th className="text-black fss-14 ps-1 w-25 pt-1 pb-1" style={{borderTop: "1px dashed", borderLeft: "1px dashed black", borderBottom: "1px dashed black" }} >NAME</th>
          <th className="text-black text-end fss-14 w-25 pt-1 pb-1"  style={{borderTop: "1px dashed",borderBottom: "1px dashed black" }}>Debit</th>
          <th className="text-black fss-14 ps-1 w-25 pt-1 pb-1" style={{borderLeft: "1px dashed", borderTop: "1px dashed",borderBottom: "1px dashed black" }}  >NAME</th>
          <th className="text-black text-end fss-14 w-25 pt-1 pb-1" style={{borderRight: "1px dashed", borderTop: "1px dashed",borderBottom: "1px dashed black" }} >Credit</th>
        </tr>
      </thead>
      <tbody className="fss-14">
        {ledger.length === 0 ? (
          <tr>
            <td colSpan="4" className="text-center">No data available</td>
          </tr>
        ) : (
          (() => {
            let rowNumber = 0;
            let rows = [];

            let positiveRows = ledger.filter(sr => sr.balance > 0);
            let negativeRows = ledger.filter(sr => sr.balance < 0);

            let maxLength = Math.max(positiveRows.length, negativeRows.length);

            for (let i = 0; i < maxLength; i++) {
              rowNumber++;
              let debitRow = negativeRows[i] || {};
              let creditRow = positiveRows[i] || {};

              rows.push(
                <tr key={`row-${rowNumber}`}>
                  {/* Debit Side */}
                  <td className="text-black pt-1 pb-1 ps-1" style={{ background: rowNumber % 2 === 0 ? "#eaeaea" : "#fff", borderLeft: "1px dashed" }}  >
                    {(debitRow.fullName || "").replace("(S)", "(B)")}
                  </td>
                  <td className="text-black text-end pt-1 pb-1" style={{ background: rowNumber % 2 === 0 ? "#eaeaea" : "#fff" }}   >
                    {debitRow.balance ? <NumberFormatter number={0 - debitRow.balance} /> : ""}
                  </td>

                  {/* Credit Side */}
                  <td className="text-black pt-1 pb-1 ps-1 " style={{ background: rowNumber % 2 === 0 ? "#eaeaea" : "#fff", borderLeft: "1px dashed" }}   >
                    {(creditRow.fullName || "").replace("(S)", "(B)")}
                  </td>
                  <td className="text-black text-end pt-1 pb-1" style={{ background: rowNumber % 2 === 0 ? "#eaeaea" : "#fff", borderRight: "1px dashed black" }}  >
                    {creditRow.balance ? <NumberFormatter number={creditRow.balance} /> : ""}
                  </td>
                </tr>
              );
            }

            // Total Row
            rowNumber++;
            rows.push(
              <tr key={`total-${rowNumber}`} className="gray-row" >
                <td className="pt-1 pb-1 fss-14 ps-1" style={{borderLeft: "1px dashed black", borderBottom: "1px dashed black" }}>Total</td>
                <td className="text-end pt-1 pb-1 fss-14" style={{borderBottom: "1px dashed black"  }} ><NumberFormatter number={debitTotalBalance} /></td>
                <td className="pt-1 pb-1 fss-14 ps-1" style={{borderLeft: "1px dashed black", borderBottom: "1px dashed black"  }}>Total</td>
                <td className="text-end pt-1 pb-1 fss-14" style={{borderRight: "1px dashed black", borderBottom: "1px dashed black"  }}><NumberFormatter number={creditTotalBalance} /></td>
              </tr>
            );

            return rows;
          })()
        )}
      </tbody>
    </Table>

              <Table responsive className='white-row' style={{borderRight: "1px dashed black", borderLeft: "1px dashed black", borderBottom: "1px dashed black "}}>
                <tbody>
                 <tr className='gray-row'><td className='text-black  text-center fss-14 d-flex justify-content-center align-items-center pt-1 pb-1'> Total Difference:&nbsp;<NumberFormatter number={differenceBalance} /> </td></tr>
                </tbody>
               </Table>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default TrialBalance;
